import Routes from "core/components/routing/routes";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import "App.css";
import { GlobalStyles } from "core/styles/global.styled";
import * as theme from "core/styles/theme";
import { AppThemeProvider, useAppTheme } from "core/contexts/theme/theme";
import { useEffect } from "react";
import { DecommissionBanner } from "core/components/layout/container/container.styled";

function AppContent() {
  const { apptheme }: any = useAppTheme();
  // BFCache prevention
   useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        // Always reload if restored from BFCache
        window.location.reload();
      }
    };

    // Empty unload handler → makes some browsers skip BFCache
    window.addEventListener("unload", () => {});
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);


  if (!apptheme) return null;

  return (
    <StyledThemeProvider theme={apptheme}>
      <GlobalStyles theme={apptheme} />

      <MUIThemeProvider
        theme={apptheme.name === "dark-theme" ? theme.darkTheme : theme.lightTheme}
      >

          <Routes />

      </MUIThemeProvider>
    </StyledThemeProvider>
  );
}

function App() {
  return (
    <AppThemeProvider>
      <AppContent />
    </AppThemeProvider>
  );
}

export default App;
